import Client from "../Client";

const getUsers = () => dispatch =>
  Client.getUsers().then(users => {
    dispatch({
      type: "GET_USERS",
      payload: { users }
    });
  });

export default getUsers;



// WEBPACK FOOTER //
// ./src/actions/users.js